<template>
  <div class="wrap">
    <div class="qrcode-block">
      <img class="qrcode-logo" src="static/img/logo_.png" alt="" />
      <div class="qrcode">
        <img :src="QrTextCodeImgUrl" style="width: 100%;height: 100%"/>
      </div>
      <div style="width: 100%;margin: 0 auto;font-size: .28rem;text-align: center;color: #999999;position: absolute;bottom: .3rem">就诊时出示此二维码</div>
    </div>
    <div class="text-block">
      <div class="text-element border">
        <div class="label">姓名</div>
        <div class="value">{{name}}</div>
      </div>
      <div class="text-element border">
        <div class="label">身份证号</div>
        <div class="value">{{idcard}}</div>
      </div>
      <div class="text-element border">
        <div class="label">手机号</div>
        <div class="value">{{phone}}</div>
      </div>
      <div class="text-element border">
        <div class="label">门诊号</div>
        <div class="value">{{MenzhenNo}}</div>
      </div>
      <div class="text-element border">
        <div class="label">住院号</div>
        <div class="value">{{ZhuyuanNo}}</div>
      </div>
      <div class="text-element" style="position: relative" @click="updateNum">
        <div class="label">就诊卡号</div>
        <div class="value">{{clinic_num}}</div>
        <div style="position: absolute;right: .4rem;font-weight: 900;color: #999999">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div style="width: 100%;height: .4rem;"></div>
    <div class="addBtn" @click="enterCardPackage">进入卡包</div>
    <div style="width: 100%;height: .4rem;"></div>
    <div class="jbBtn" @click="jbhealthCard">解绑电子健康卡</div>
    <div style="width: 100%;height: .8rem;"></div>
  </div>
</template>

<script>
  import {getCardOne,UpdateHisNo,DelJiuzhenren,getOrderId} from '../../api/index'
    export default {
      data(){
        return{
          name:'',
          idcard:'',
          phone:'',
          QrTextCodeImgUrl:'',
          clinic_num:'',
          MenzhenNo:'',
          ZhuyuanNo:'',
          strqrCodeText:''
        }
      },
      created() {
        //修改标题
        document.title = '电子健康卡信息'
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        getCardOne(this.$route.query.id).then(res=>{
          loading.close();
          this.name = res.Data.clinic_patient_name
          this.idcard = res.Data.idCard
          this.phone = res.Data.phone
          this.QrTextCodeImgUrl = res.Data.QrTextCodeImgUrl
          this.clinic_num = res.Data.clinic_num
          this.MenzhenNo = res.Data.MenzhenNo
          this.ZhuyuanNo = res.Data.ZhuyuanNo
          this.strqrCodeText = res.Data.qrCodeText
        })
      },
      methods:{
        updateNum(){
          this.$prompt('请输入就诊卡号', '修改就诊卡号', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(({ value }) => {
            UpdateHisNo(this.$route.query.id,{clinic_num:value}).then(r=>{
              if(r.IsSuccess){
                this.$message({
                  type: 'success',
                  message: '修改成功！',
                  duration:3000,
                  offset:200
                });
                this.clinic_num = value
              }else {
                this.$message({
                  message: r.Msg,
                  type: 'error',
                  duration:3000,
                  center:true,
                  offset:200
                });
                return
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '取消修改！',
              duration:3000,
              offset:200
            });
          });
        },
        //解绑电子健康卡
        jbhealthCard(){
          this.$confirm('你是否确定删除此就诊人?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            DelJiuzhenren({
              openid:this.$storage.get('openid'),
              unionid:this.$storage.get('unionid'),
              mpUserClinicId:this.$route.query.id
            }).then(res=>{
              //删除默认就诊人
              this.$storage.remove('patient')
              if(res.IsSuccess){
                this.$message({
                  message: '解绑电子健康卡成功！',
                  type: 'success',
                  duration:3000,
                  center:true,
                  offset:200
                });
                this.$router.push({path:'/personManage'})
              }else {
                this.$message({
                  message: res.Msg,
                  type: 'error',
                  duration:3000,
                  center:true,
                  offset:200
                });
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
              duration:3000,
              center:true,
              offset:200
            });
          });
        },
        //进入卡包
        enterCardPackage(){
          getOrderId({
            strqrCodeText:this.strqrCodeText
          }).then(res=>{
            if(res.IsSuccess){
              console.log(res.Data)
              window.location.href = 'https://health.tengmed.com/open/takeMsCard?order_id='+res.Data+'&redirect_uri='+encodeURIComponent(location.protocol + '//' + location.host +'/#/healthCardDetails?id='+this.$route.query.id)
            }else {
              this.$message({
                type: 'error',
                message: res.Msg,
                duration:3000,
                center:true,
                offset:200
              });
            }
          })
        }
      }
    }
</script>

<style scoped>
  @import "../../../static/css/personal.css";
  .addBtn {
    display: block;
    background: #409EFF;
    border-radius: .1rem;
    width: 6.6rem;
    height: .8rem;
    line-height: .8rem;
    font-size: .32rem;
    color: #FFFFFF;
    margin: 0 auto;
    text-align: center;
  }
  .jbBtn {
    display: block;
    background: #E20B17;
    border-radius: .1rem;
    width: 6.6rem;
    height: .8rem;
    line-height: .8rem;
    font-size: .32rem;
    color: #FFFFFF;
    margin: 0 auto;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/healthCardDetails.vue